import http from "@/utils/httpRequest";

// 查询顶部快捷入口添加列表
export const APIwbconveniententrancegetConvenientConfigList = (params) => {
  return http.post(
    "/wbConvenientConfig/getConvenientConfigList",
    { ...params },
    { baseURL }
  );
};
// 查询顶部快捷入口-列表
export const APIwbconveniententranceconvenientList = (params) => {
  return http.post(
    "/wbconveniententrance/convenientList",
    { ...params },
    { baseURL }
  );
};
